import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table, Modal,
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import EyeIcon from 'mdi-react/EyeIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import AccountSearchIcon from 'mdi-react/AccountSearchIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderFileInputField from '../../../../shared/components/form/FileInput';
import renderSelectField from '../../../../shared/components/form/Select';
import renderMultiSelectField from '../../../../shared/components/form/MultiSelect';
import { MDBDataTable, MDBBtn, MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import axios from "axios";
import Select from 'react-select';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as Excel from 'exceljs';
import Util from '../../../Common/util';
import API from '../../../Common/api';

/*import './styles.css';
*/

var url = window.location.hostname;
var port = window.location.port;

const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';







class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.toggle = this.toggle.bind(this);
    this.Errortoggle = this.Errortoggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.fetchGRNData = this.fetchGRNData.bind(this);
    this.btnClick = this.btnClick.bind(this);
    this.EditToggle = this.EditToggle.bind(this);
    this.togglePressCancel = this.togglePressCancel.bind(this);
    this.showTypeahead = this.showTypeahead.bind(this);
    this.showTypeaheadChange = this.showTypeaheadChange.bind(this);
    this.closeContainer = this.closeContainer.bind(this);
    this.setBinId = this.setBinId.bind(this);
    this.onQuantityChange1 = this.onQuantityChange1.bind(this);
    this.changeICLDQty = this.changeICLDQty.bind(this);
    this.changeLooseQty = this.changeLooseQty.bind(this);
    this.changeTesterQty = this.changeTesterQty.bind(this);
    this.processData = this.processData.bind(this);
    this.CancelErrorToggle = this.CancelErrorToggle.bind(this);
    this.ConfirmPutAway = this.ConfirmPutAway.bind(this);
    this.Successtoggle = this.Successtoggle.bind(this);
    this.CancelSuccessToggle = this.CancelSuccessToggle.bind(this);
    this.Confirmtoggle = this.Confirmtoggle.bind(this);
    this.CancelConfirmToggle = this.CancelConfirmToggle.bind(this);
    this.processUpdateData = this.processUpdateData.bind(this);
    this.CancelErrorMessageToggle = this.CancelErrorMessageToggle.bind(this);
    this.ErrorMessagetoggle = this.ErrorMessagetoggle.bind(this);
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.handleFile1 = this.handleFile1.bind(this);
    this.handleFile2 = this.handleFile2.bind(this);
    /*this.showTypeahead = this.showTypeahead.bind(this);*/
    this.state = {
      showPassword: false,
      loading: false,
      schemas: [],
      showFetchGRNData: false,
      loadingupdatebtn: false,
      pickingHistoryId: '',
      rows: [],
      grnNumber: '',
      grnValues: '',
      selectedOptions: '',
      errorMessage: '',
      changeStatus: '',
      loadingbtn: false,
      alertMessage: '',
      messageModal: false,
      ErrorMessagemodal: false,
      postsGRN: [],
      postsProduct: [],
      tableRowsGRN: [],
      ErrorRowData: [],
      options: [],
      newArrayData: [],
      selectedUser: {},
      modal: false,
      Confirmmodal: false,
      EditModal: false,
      typeaheadText: '',
      pkd_val: '',
      lbskuid_val: '',
      mrp_val: '',
      quantity: '',
      defaultquantity: '',
      putawayHistoryId: '',
      showTypeahead: false,
      zwz_search_pannel: false,
      data: [],
      binId: '',
      hover_nod_data: [],
      showContainer: [],
      setBinIdLoop: {},
      splitData: [],
      Errormodal: false,
      Successmodal: false,
      ErrorMessage: '',
      SuccessMessage: '',
      showICLDError: false,
      showLooseError: false,
      showTesterError: false


    };
  }


  /*exportToCSV = (csvData, FileName) => {
  

    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], {type: fileType});
    FileSaver.saveAs(data, FileName + " Batch" + fileExtension);
  }*/





  exportToCSV = (csvData, FileName) => {
    try {
      var workbook = new Excel.Workbook();
      console.log("exportToCSV", workbook)
      var worksheet = workbook.addWorksheet('My Sheet');

      worksheet.addRow({})
      worksheet.addRow(["", "Product", "PKD", "MRP", "QTY", "CBU Code", "Product", "PKD", "MRP", "QTY", "CBU Code", "", "Product", "PKD", "QTY", "Product", "PKD", "QTY"]);

      csvData.map(item => worksheet.addRow([item['Bin Address'], item['System Sku Id'], item['System PKD'], item['System MRP'], item['System Qty'], item['System CBU'], item['Scanned Sku Id'], item['Scanned PKD'], item['Scanned MRP'], item['Scanned Qty'], item['Scanned CBU'], item['Status'], item['Excess Sku Id'], item['Excess PKD'], item['Excess Qty'], item['Short Sku Id'], item['Short PKD'], item['Short Qty']]))

      worksheet.mergeCells('B1:F1');
      worksheet.mergeCells('G1:K1');
      worksheet.mergeCells('M1:O1');
      worksheet.mergeCells('P1:R1');

      worksheet.getCell('A1').value = 'Bin Address';
      worksheet.getCell('B1').value = 'System';
      worksheet.getCell('G1').value = 'Physical/Scanned';
      worksheet.getCell('L1').value = 'Status';
      worksheet.getCell('M1').value = 'Excess (Physical)';

      worksheet.getCell('P1').value = 'Short (Physical)';

      // FileSaver.saveAs(worksheet, FileName + " Batch" + fileExtension);

      console.log("Generating data")
      workbook.xlsx.writeBuffer().then((data) => {
        var blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        console.log("Data generated")
        FileSaver.saveAs(blob, FileName + " Batch" + fileExtension);
      })
    } catch (error) {
      console.log(error)
    }
    // const ws = XLSX.utils.json_to_sheet(csvData);
    // const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    // const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    // const data = new Blob([excelBuffer], {type: fileType});

  }




  processUpdateData() {

    if (this.state.checkicldQty < this.state.icldQty) {
      this.setState({
        showICLDError: true
      })
      return false;
    } else {

      this.setState({
        showICLDError: false
      })

    }

    if (this.state.checklooseQty < this.state.looseQty) {
      this.setState({
        showLooseError: true
      })
      return false;
    } else {

      this.setState({
        showLooseError: false
      })

    }

    if (this.state.checktesterQty < this.state.testerQty) {
      this.setState({
        showTesterError: true
      })
      return false;
    } else {

      this.setState({
        showTesterError: false
      })

    }


    const payload = {
      pickedIcldQty: this.state.icldQty,
      pickedLooseQty: this.state.looseQty,
      pickedTesterQty: this.state.testerQty,
      pickingHistoryId: this.state.pickingHistoryId
    };

    API.post('/picking/editPicking/v1/', { param: payload })
      .then((response) => {

        if (response.data.success === true) {
          this.setState({
            EditModal: false
          })
        }

        this.fetchGRNData();


        console.log(response);

      })
      .catch(function (error) {


      });


  }

  ErrorMessagetoggle() {
    this.setState({
      ErrorMessagemodal: true,
    })
  }

  CancelErrorMessageToggle() {
    this.setState({
      ErrorMessagemodal: false,
    })
  }


  handleFile1() {

    console.log("sdfghjdfg");
    const payload = {
      id: localStorage.getItem('fileName'),
      print: "ptl",
      location: this.state.selectedLocation,
    };

    API.post('/picking/printSheet/v1/', { param: payload })
      .then((response) => {


        console.log(JSON.stringify(response.data));
        /*alert(response.data.success_response[0].message);
        this.fetchGRNData();*/
        var new_data = {};

        for (var i = 0; i < response.data.length; i++) {
          var tmp = response.data[i];
          if (new_data[tmp.userName] == undefined) {
            new_data[tmp.userName] = [response.data[i]];
          } else {
            new_data[tmp.userName].push(response.data[i]);
          }

        }

        console.log(new_data);
        localStorage.setItem('printData', JSON.stringify(new_data));
        console.log(localStorage.getItem('printData'));

        /*window.location.href="/print_data";*/
        /* if (window.location.href="/putaway/printPutaway") {
           window.location.reload();
         }*/

        this.setState({
          loadingprintbtn: false,
          modal: false,
          showAssignButton: false,
          showPrintButton: true,
        })
        window.open('/printPickigDetail', '_blank');

      })
      .catch(function (error) {



      });

  }

  handleFile2() {

    console.log("sdfghjdfg");
    const payload = {
      batch_id: localStorage.getItem('batchNo'),

      location: this.state.selectedLocation,
    };

    API.post('/cycle_count/cycleReconReportV2/', { param: payload })
      .then((response) => {

        console.log(response);
        console.log(JSON.stringify(response.data));
        this.exportToCSV(response.data, localStorage.getItem('batchNo'));

        /*alert(response.data.success_response[0].message);
        this.fetchGRNData();*/
        /*     var new_data = {};
     
             for(var i=0;i < response.data.length;i++){
                  var tmp = response.data[i];
                  if(new_data[tmp.userName] == undefined){
                      new_data[tmp.userName] = [response.data[i]];
                  }else{
                       new_data[tmp.userName].push(response.data[i]);
                  }
             
             }
     
             console.log(new_data);
             localStorage.setItem('printData' , JSON.stringify(new_data));
             console.log(localStorage.getItem('printData'));
     
           
     
             this.setState({
               loadingprintbtn: false,
               modal: false,
               showAssignButton: false,
               showPrintButton: true,
             })*/


      })
      .catch(function (error) {



      });

  }







  changeICLDQty(evt) {
    this.setState({
      icldQty: evt.target.value
    })

    console.log(this.state.icldQty);
  }

  changeLooseQty(evt) {
    this.setState({
      looseQty: evt.target.value
    })

    console.log(this.state.looseQty);
  }

  changeTesterQty(evt) {
    this.setState({
      testerQty: evt.target.value
    })

    console.log(this.state.testerQty);
  }

  EditToggle() {
    this.setState({
      EditModal: true
    })
  }

  setBinId(item) {
    this.setState({
      typeaheadText: item
    })

  }

  CancelConfirmToggle() {
    this.setState({
      Confirmmodal: false
    })
    window.location.reload();
  }

  onQuantityChange1(index, value) {
    const { rows } = this.state
    this.setState({
      rows: rows.map((item, i) => i === index ? { ...item, qty: value } : item),
    })

  }

  ConfirmPutAway() {
    console.log(this.state.postsGRN);
    this.setState({
      loadingbtn: true
    })

    var arr = [];
    for (var i = 0; i < this.state.postsGRN.length; i++) {


      var orderData = {};
      orderData['pickingHistoryId'] = this.state.postsGRN[i].pickingHistoryId;
      orderData['location'] = this.state.selectedLocation;


      /*orderData['remarks'] = 'dfghjk';*/

      console.log(orderData);


      arr.push(orderData);
    }

    const payload = {
      arr_data: arr,
    };

    API.post('/picking/confirmPicking/v1/', { param: payload })
      .then((response) => {


        console.log(response);
        /*this.setState({
            Successmodal: true,
          })*/



        if (response.data[0].success === false) {
          this.setState({
            errorMessage: response.data[0].reason,
            ErrorMessagemodal: true,
            loadingbtn: false
          })
        } else {
          this.Confirmtoggle();
          this.setState({
            loadingbtn: false,
          })
        }

        /*window.location.reload();*/
        /* if (response.data[0].success= true) {
           this.setState({
             Successmodal: true,
           })

           window.location.reload();
         }*/

      })
      .catch(function (error) {


      });


  }

  CancelErrorToggle() {
    this.setState({
      Errormodal: false,
    })

    this.handleRemoveRow();
  }

  CancelSuccessToggle() {
    this.setState({
      Successmodal: false,
    })

  }

  CancelSuccessToggle() {
    this.setState({
      Successmodal: false,
    })

  }

  onBinChange1(index, value) {
    /*showTypeahead = (e) => {*/

    /*const data_val = ["B-W-R-2" , "C-D-T-3" , "C-D-T-8" , "C-D-T-8"];*/

    /*console.log(e.target.value);*/

    let { showContainer, rows } = this.state
    showContainer[index] = true
    this.setState({
      showContainer,
      rows: rows.map((item, i) => i === index ? { ...item, binId: value } : item),
      /*data: data_val*/
    }, () => {
      const payload = {
        location: this.state.selectedLocation,
        binAddress: value,
        putawayHistoryId: this.state.putawayHistoryId
      };

      API.post('/picking/getBins/v1/', { param: payload })
        .then((response) => {


          console.log(response);
          this.setState({
            data: response.data,
          })

        })
        .catch(function (error) {


        })
    })

    /*console.log(value);*/



  }

  setBinIdLoop(index, value) {
    const { rows, showContainer } = this.state
    this.setState({
      rows: rows.map((item, i) => i === index ? { ...item, binId: value } : item),
      showContainer: showContainer.map((item, i) => false)
    })
  }


  hideTypeahead = (e) => {
    if (this.state.showTypeahead) {
      if (!this.typeahead.contains(e.target)) {
        this.setState({ showTypeahead: false })
      }
    }
  }




  handleAddRow = () => {
    this.setState((prevState, props) => {
      const row = {};
      return { rows: [...prevState.rows, row] };
    });
  };

  handleRemoveRow = () => {
    this.setState((prevState, props) => {
      return { rows: prevState.rows.slice(1) };
    });
  };

  handleRemoveRow1 = () => {
    this.setState((prevState, props) => {
      return {
        rows: prevState.rows.slice(6)
      };
    });
  };

  handleRemoveRow2 = () => {
    this.setState((prevState, props) => {
      return {
        rows: prevState.rows.slice(0)
      };
    });
  };

  showTypeaheadChange = (e) => {
    const value = e.target.value
    this.setState({
      quantity: value
    })
  }

  showTypeahead = (e) => {
    const value = e.target.value
    this.setState({
      typeaheadText: value
    }, () => {
      /*const data_val = ["B-W-R-2" , "C-D-T-3" , "C-D-T-8" , "C-D-T-8"];*/
      this.setState({
        showTypeahead: true,
        zwz_search_pannel: true,
        /* data: data_val*/
      })

      const payload = {
        location: this.state.selectedLocation,
        binAddress: value,
        putawayHistoryId: this.state.putawayHistoryId
      };

      API.post('/picking/getBins/v1/', { param: payload })
        .then((response) => {


          console.log(response);
          this.setState({
            data: response.data,
          })

        })
        .catch(function (error) {


        });
    })
  }

  closeContainer() {
    this.setState({
      showTypeahead: false
    })
  }

  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  Confirmtoggle() {
    this.setState(prevState => ({ Confirmmodal: !prevState.Confirmmodal }));
  }

  Errortoggle() {
    this.setState(prevState => ({ Errormodal: !prevState.Errormodal }));
  }


  Successtoggle() {
    this.setState(prevState => ({ Successmodal: !prevState.Successmodal }));
  }


  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };


  togglePressCancel() {
    this.setState({
      EditModal: false,
    })
  }

  handleChange(event) {
    this.setState({
      value: event.target.data,
      grnValues: event.target.value

    });

    console.log(this.state.grnValues);
    console.log(event.target.value);

    localStorage.setItem('batchNo', event.target.value)



  }


  componentWillMount() {

    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090"
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088"
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8090";

    } else {
      url = window.location.hostname + port;
    }


    var cookieUsername = this.getCookie('token');
    var Location = this.getCookie('selectedLocation');
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: Location,
    })

    localStorage.setItem('userName', username);
  }



  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }


  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }




  componentDidMount() {
    const payload = {
      location: this.state.selectedLocation,
    };

    API.post('/cycle_count/fetchCycleCountBatch/v1/', { param: payload })
      .then((response) => {


        console.log(response);
        this.setState({
          schemas: response.data
        });
      })
      .catch(function (error) {


      });

    /*this.fetchGRNData();*/
  }

  fetchGRNData() {

    var fileNameValue = localStorage.getItem('fileName')
    this.setState({
      showFetchGRNData: true,
      loading: true,
      postsGRN: [],
      tableRowsGRN: [],


    })


    const payload = {
      fileName: fileNameValue, pickType: 2
    };

    API.post('/picking/fetchPicksheetInfo/v1/', { param: payload })
      .then(response => response.data)

      .then(data => {

        // console.log(data);

        // if (err) throw err;

        this.setState({ postsGRN: data })



      })

      .then(async () => {

        this.setState({ tableRowsGRN: this.assemblePostsGRN(), isLoading: false, loading: false })

        console.log(this.state.tableRowsGRN);

      });
  }

  assemblePostsGRN = () => {

    let postsGRN = this.state.postsGRN.map((post, index) => {

      return (

        {

          /*grnNumber: post.grnNumber,

          gnrLineNumber: post.gnrLineNumber,*/

          /*putawayHistoryId: post.putawayHistoryId,*/
          /*status: post.status == 'UNHOLD' ? <MDBBtn onClick={r => this.btnClick(post.putawayHistoryId, post.status)} style={{backgroundColor: '#4ce1b6' , color: '#fff'}} color="default" rounded size="sm">Hold</MDBBtn> : <MDBBtn  style={{backgroundColor: '#de5361', color: '#fff'}} onClick={r => this.btnClick(post.putawayHistoryId, post.status)} rounded size="sm">Release</MDBBtn>,*/

          serial: index + 1,

          /*grnNumber: post.grnNumber,

          gnrLineNumber: post.gnrLineNumber,*/

          /*putawayHistoryId: post.putawayHistoryId,*/
          /*status: post.status == 'UNHOLD' ? <MDBBtn onClick={r => this.btnClick(post.putawayHistoryId, post.status)} style={{backgroundColor: '#4ce1b6' , color: '#fff'}} color="default" rounded size="sm">Hold</MDBBtn> : <MDBBtn  style={{backgroundColor: '#de5361', color: '#fff'}} onClick={r => this.btnClick(post.putawayHistoryId, post.status)} rounded size="sm">Release</MDBBtn>,*/


          binId: post.binAddress,

          zone_name: post.zoneName,

          zone_id: post.zoneId,

          lbskuid: post.lbSkuId,

          pickType: post.pickType,
          mrp: post.mrp,
          cbuCode: post.cbuCode,

          toPickIcldQty: post.toPickIcldQty + ' pcs',

          toPickLooseQty: post.toPickLooseQty + ' pcs',

          toPickTesterQty: post.toPickTesterQty + ' pcs',

          PickIcldQty: post.pickedIcldQty + ' pcs',

          PickLooseQty: post.pickedLooseQty + ' pcs',

          PickTesterQty: post.pickedTesterQty + ' pcs',


          pkd: post.pkd,

          action: <span onClick={r => this.btnClick(post.lbSkuId, post.pkd, post.mrp, post.binAddress, post.pickingHistoryId, post.toPickIcldQty, post.toPickLooseQty, post.toPickTesterQty)} style={{ cursor: 'pointer', color: '#3ea3fc' }}>Edit</span>,

        }

      )

    });

    return postsGRN;

  }


  btnClick(LBSKUID, PKD, MRP, BinAddress, PickingHistoryId, ICLDQTY, LOOSEQTY, TESTERQTY) {

    this.setState({
      EditModal: true,
      /* typeaheadText: binId,*/
      pickingHistoryId: PickingHistoryId,
      binId: BinAddress,
      pkd_val: PKD,
      lbskuid_val: LBSKUID,
      mrp_val: MRP,
      icldQty: ICLDQTY,
      looseQty: LOOSEQTY,
      testerQty: TESTERQTY,
      checkicldQty: ICLDQTY,
      checklooseQty: LOOSEQTY,
      checktesterQty: TESTERQTY,
      showTesterError: false,
      showICLDError: false,
      showLooseError: false,

    })

    console.log(LBSKUID);
    console.log(this.state.lbskuid_val);



  }


  processData() {

    var orderData = {};


    orderData['binAddress'] = this.state.typeaheadText;
    orderData['newPutawayQty'] = this.state.quantity;
    this.state.splitData.push(orderData);

    var total_Quantity = this.state.quantity;

    for (var i = 0; i < this.state.rows.length; i++) {
      var neworderData = {};
      neworderData['binAddress'] = this.state.rows[i].binId;
      neworderData['newPutawayQty'] = this.state.rows[i].qty;

      console.log(neworderData);

      total_Quantity = parseInt(total_Quantity) + parseInt(this.state.rows[i].qty);


      this.state.splitData.push(neworderData);
    }

    console.log(total_Quantity);

    /*if (this.state.defaultquantity < total_Quantity) {
      
      this.setState({
        ErrorMessage: 'Total quantity split exceeds the available quantity',
        Errormodal: true,
      })

      return false;
    }*/



    const payload = {
      putawayHistoryId: this.state.putawayHistoryId,
      newPutaway: this.state.splitData,
      location: this.state.selectedLocation,
    };

    API.post('/picking/splitPutaway/v1/', { param: payload })
      .then((response) => {


        console.log(response);

        if (response.data.success_response.length > 0) {
          this.setState({
            schemas: response.data,
            modal: false,
            Successmodal: true,
            ErrorMessage: "Successfully Updated",
            rows: [],
            splitData: [],

          });

          this.fetchGRNData();
        } else if (response.data.failure_response.length > 0) {
          this.handleRemoveRow2();
          this.setState({
            ErrorMessage: response.data.failure_response[0].reason,
            Errormodal: true,
            /*rows: [],*/
            splitData: [],
          })
        }

        console.log(this.state.rows);
      })
      .catch(function (error) {


      });








    /*console.log(this.state.splitData);*/




  }




  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modal } = this.state;
    const { Errormodal } = this.state;
    const { Successmodal } = this.state;
    const { Confirmmodal } = this.state;
    const { EditModal } = this.state;
    const { ErrorMessagemodal } = this.state;

    const GRNData = {

      columns: [

        /* {
 
           label:'GRN Number',
 
           field:'grnNumber',
 
         },
 
         {
 
           label:'GRN Line Number',
 
           field:'gnrLineNumber',
 
         },*/

        /*{

          label:'PutAway History',

          field:'putawayHistoryId',

        },*/



        {

          label: 'S No.',

          field: 'serial',
          minimal: 'sm'

        },


        {

          label: 'BIN Id',

          field: 'binId',
          minimal: 'lg'

        },

        {

          label: 'Zone Name',

          field: 'zone_name',
          minimal: 'lg'

        },

        {

          label: 'Zone Id',

          field: 'zone_id',
          minimal: 'lg'

        },

        {

          label: 'LB SKU ID',

          field: 'lbskuid',
          minimal: 'lg'

        },

        {

          label: 'Pick Type',

          field: 'pickType',
          minimal: 'lg'

        },






        {

          label: 'MRP',

          field: 'mrp',
          minimal: 'lg'

        },

        {

          label: 'CBU Code',

          field: 'cbuCode',
          minimal: 'lg'

        },


        {

          label: 'To Pick Icld Quantity',

          field: 'toPickIcldQty',
          minimal: 'lg'

        },

        {

          label: 'To Pick Loose Quantity',

          field: 'toPickLooseQty',
          minimal: 'lg'

        },

        {

          label: ' To Pick Tester Quantity',

          field: 'toPickTesterQty',
          minimal: 'lg'

        },

        {

          label: 'Picked Icld Quantity',

          field: 'PickIcldQty',
          minimal: 'lg'

        },

        {

          label: 'Picked Loose Quantity',

          field: 'PickLooseQty',
          minimal: 'lg'

        },

        {

          label: 'Picked Tester Quantity',

          field: 'PickTesterQty',
          minimal: 'lg'

        },

        {

          label: 'PKD',

          field: 'pkd',
          minimal: 'lg'

        },



        {

          label: 'Action',

          field: 'action',
          minimal: 'lg'

        },





      ],

      rows: this.state.tableRowsGRN,

    }

    console.log(this.state.rows)

    return (
      <Col xl={12}>
        <Card>
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text"></h5>

            </div>
            <form className="form form--inline" onSubmit={handleSubmit}>

              <div className="form__form-group col-xl-5" style={{ display: 'inline-flex' }}>

                <span className="form__form-group-label col-xl-5" style={{ display: 'inline', paddingTop: 6, paddingBottom: 6 }} >Select Batch No.</span>



                <div className="form__form-group-field col-xl-4" style={{ display: 'contents' }}>
                  <select className="form-control" value={this.state.value} style={{ fontSize: 13 }} onChange={this.handleChange}>
                    <option value="0">Select Batch No.</option>
                    {
                      (this.state.schemas && this.state.schemas.length > 0) && this.state.schemas.map((schema) => {
                        return (<option value={schema}> {schema}</option>);
                      })
                    }
                  </select>
                </div>


              </div>



              <div className="form__form-group col-xl-1" style={{ display: 'none' }}>

                <div className="form__form-group-field">
                  <ButtonToolbar className="form__button-toolbar">

                    <input value="Print" color="primary" style={{ backgroundColor: 'rgb(112, 187, 253)', color: '#fff', paddingTop: 7, paddingBottom: 7, paddingLeft: 25, paddingRight: 25 }} className="btn-sm" onClick={this.handleFile1} type="button" />

                  </ButtonToolbar>


                </div>

              </div>

              <div className="form__form-group col-xl-3">

                <div className="form__form-group-field">
                  <ButtonToolbar className="form__button-toolbar">

                    <input value="Export to excel" color="primary" style={{ backgroundColor: 'rgb(112, 187, 253)', color: '#fff', paddingTop: 7, paddingBottom: 7, paddingLeft: 25, paddingRight: 25 }} className="btn-sm" onClick={this.handleFile2} type="button" />

                  </ButtonToolbar>


                </div>

              </div>

            </form>
          </CardBody>

          {this.state.showFetchGRNData &&

            <CardBody style={{ marginTop: 20 }}>
              <div className="table_header">


                <ButtonToolbar className="form__button-toolbar">
                  <Button color="primary" className="btn-sm" onClick={this.ConfirmPutAway} type="submit">
                    {this.state.loadingbtn &&
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }
                    Confirm</Button>
                </ButtonToolbar>
              </div>


              <MDBTable scrollX={true} striped bordered>
                <MDBTableHead columns={GRNData.columns} />
                <MDBTableHead>
                  {this.state.loading &&
                    <div style={{ width: '2300%', textAlign: 'center', paddingTop: 22 }}>
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px", fontSize: 18 }}
                      />
                    </div>
                  }

                </MDBTableHead>
                <MDBTableBody rows={GRNData.rows} />
              </MDBTable>


            </CardBody>
          }
        </Card>

        <Modal
          isOpen={modal}
          toggle={this.toggle}
          style={{ maxWidth: 700, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: '#70bbfd' }}>
            <h4 className="text-modal  modal__title" style={{ color: '#fff', paddingTop: 10 }}>Split Quantity</h4>
          </div>
          <div className="modal__body" style={{ marginTop: 10, padding: 16 }}>
            <div style={{ width: '100%' }}>
              <div style={{ width: '30%', float: 'left', textAlign: 'left' }}>
                <span style={{ fontSize: 15 }}><span style={{ fontWeight: 'bold' }}> LB SKU ID: </span> <span> {this.state.lbskuid_val} </span> </span>
              </div>

              <div style={{ width: '22%', float: 'left', textAlign: 'right' }}>
                <span style={{ fontSize: 15 }}><span style={{ fontWeight: 'bold' }}> ICLD Qty: </span> <span> {this.state.defaultquantity} </span> </span>
              </div>

              <div style={{ width: '22%', float: 'left', textAlign: 'right' }}>
                <span style={{ fontSize: 15 }}><span style={{ fontWeight: 'bold' }}> PKD: </span> <span> {this.state.pkd_val} </span> </span>
              </div>

              <div style={{ width: '25%', float: 'left', textAlign: 'right' }}>
                <span style={{ fontSize: 15 }}><span style={{ fontWeight: 'bold' }}> MRP: </span> <span> {this.state.mrp_val} </span> </span>
              </div>

            </div>

            <table
              className="table table-bordered table-hover"
              id="tab_logic"
            >

              <thead style={{ textAlign: 'left' }}>
                <tr>
                  <th>BIN</th>
                  <th>QTY</th>


                </tr>
              </thead>
              <tbody>

                <tr>
                  <td style={{ textAlign: 'left' }}>

                    <div className="search-container">
                      <div className="react-search-field test-class">
                        <input
                          className="react-search-field-input"
                          placeholder="Search for Bearing No."
                          type="text"
                          style={{ padding: 4, borderRadius: 2 }}
                          defaultValue={this.state.typeaheadText}
                          value={this.state.typeaheadText}
                          onChange={this.showTypeahead}

                        />

                      </div>

                      {
                        this.state.showTypeahead && (
                          <div className="suggestions-container" ref={el => this.typeahead = el}>
                            {this.state.zwz_search_pannel && (
                              <div className="suggestions" onClick={this.closeContainer}>


                                {
                                  this.state.data.length > 0 && (
                                    this.state.data.map((item, index) => <p key={index} onClick={() => this.setBinId(item.binAddress)} className="typeahead-text">{item.binAddress} </p>)
                                  )


                                }


                              </div>

                            )}

                          </div>
                        )
                      }
                    </div>
                  </td>
                  <td style={{ textAlign: 'left' }}>
                    <input type="text" value={this.state.quantity} onChange={this.showTypeaheadChange} style={{ padding: 4, borderRadius: 2 }} />
                    <i onClick={this.handleAddRow} class="fa fa-plus-circle" style={{ marginLeft: 15, fontSize: 17, cursor: 'pointer' }}></i>
                    <i onClick={this.handleRemoveRow} class="fa fa-minus-circle" aria-hidden="true" style={{ marginLeft: 15, fontSize: 17, cursor: 'pointer' }}></i>
                  </td>

                </tr>

                {this.state.rows.map((row, index) => (

                  <tr>
                    <td style={{ textAlign: 'left' }}>

                      <div className="search-container">
                        <div className="react-search-field test-class">
                          <input
                            className="react-search-field-input"
                            placeholder="Search for Bin Address"
                            type="text"
                            style={{ padding: 4, borderRadius: 2 }}
                            value={row.binId}
                            onChange={(e) => this.onBinChange1(index, e.target.value)}

                          />

                        </div>

                        {
                          this.state.showContainer[index] && (
                            <div className="suggestions-container" ref={el => this.typeahead = el}>
                              <div className="suggestions" onClick={this.closeContainer}>


                                {
                                  this.state.data.length > 0 && (
                                    this.state.data.map((item, i) => <p key={i} onClick={() => this.setBinIdLoop(index, item.binAddress)} className="typeahead-text">{item.binAddress} </p>)
                                  )


                                }


                              </div>

                            </div>
                          )
                        }



                      </div>


                    </td>
                    <td style={{ textAlign: 'left' }}>
                      <input type="text" onChange={(e) => this.onQuantityChange1(index, e.target.value)} style={{ padding: 4, borderRadius: 2 }} />
                    </td>
                  </tr>
                ))}

              </tbody>
            </table>



            <ButtonToolbar className="modal__footer">
              <button  className="modal_cancel" onClick={this.togglePressCancel}>Cancel</button>
              <Button style={{ backgroundColor: '#24d6a3', color: '#fff', marginLeft: 12 }} className="modal_ok" onClick={this.processData}>Submit</Button>
            </ButtonToolbar>
          </div>

        </Modal>


        <Modal
          isOpen={EditModal}
          toggle={this.EditToggle}
          style={{ maxWidth: 500, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: '#70bbfd' }}>
            <h4 className="text-modal  modal__title" style={{ color: '#fff', paddingTop: 10 }}>Edit Entry</h4>
          </div>
          <div className="modal__body" style={{ padding: 12 }}>
            <div style={{ width: '100%' }}>
              <div style={{ width: '50%', float: 'left', textAlign: 'left' }}>
                <span style={{ fontSize: 15 }}><span style={{ fontWeight: 'bold' }}> LB SKU ID: </span> <span> {this.state.lbskuid_val} </span> </span>
              </div>

              <div style={{ width: '50%', float: 'left', textAlign: 'right' }}>
                <span style={{ fontSize: 15 }}><span style={{ fontWeight: 'bold' }}> BIN ID: </span> <span> {this.state.binId} </span> </span>
              </div>

              <div style={{ width: '50%', float: 'left', textAlign: 'left' }}>
                <span style={{ fontSize: 15 }}><span style={{ fontWeight: 'bold' }}> PKD: </span> <span> {this.state.pkd_val} </span> </span>
              </div>

              <div style={{ width: '50%', float: 'left', textAlign: 'right' }}>
                <span style={{ fontSize: 15 }}><span style={{ fontWeight: 'bold' }}> MRP: </span> <span> {this.state.mrp_val} </span> </span>
              </div>

            </div>
            <Table responsive className="table--bordered" style={{ marginBottom: 10, marginTop: 15 }}>
              <tbody>


                <tr>
                  <td>Pick Qty ICLD</td>
                  <td><input type="text" defaultValue={this.state.icldQty} onChange={this.changeICLDQty} style={{ padding: 4, borderRadius: 2 }} />
                    <br />
                    {this.state.showICLDError && (
                      <span style={{ fontSize: 11, color: 'red' }}> Pick Icld quantity exceeds actual pick quantity </span>

                    )}
                  </td>


                </tr>

                <tr>
                  <td>Pick Qty LOOSE</td>
                  <td><input type="text" defaultValue={this.state.looseQty} onChange={this.changeLooseQty} style={{ padding: 4, borderRadius: 2 }} />
                    <br />
                    {this.state.showLooseError && (
                      <span style={{ fontSize: 11, color: 'red' }}> Pick Loose quantity exceeds actual quantity </span>

                    )}
                  </td>


                </tr>

                <tr>
                  <td>Pick Qty Tester</td>
                  <td><input type="text" defaultValue={this.state.testerQty} onChange={this.changeTesterQty} style={{ padding: 4, borderRadius: 2 }} />
                    <br />
                    {this.state.showTesterError && (
                      <span style={{ fontSize: 11, color: 'red' }}> Pick Tester quantity exceeds actual pick quantity </span>

                    )}
                  </td>


                </tr>







              </tbody>
            </Table>

            <ButtonToolbar className="modal__footer">
              <button  className="modal_cancel" onClick={this.togglePressCancel}>Cancel</button>
              <Button style={{ backgroundColor: '#24d6a3', color: '#fff', marginLeft: 12, backgroundColor: '#3ea3fc' }} className="modal_ok" onClick={this.processUpdateData}>
                {this.state.loadingupdatebtn &&
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                }
                Update</Button>
            </ButtonToolbar>
          </div>

        </Modal>





        <Modal
          isOpen={Errormodal}
          toggle={this.Errortoggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{ right: 15 }} onClick={this.Errortoggle} />


          </div>
          <div className="modal__body" style={{ paddingTop: 55, paddingBottom: 20 }}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{ color: 'red' }} />
            <h4>{this.state.ErrorMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{ backgroundColor: '#24d6a3', color: '#fff' }} className="modal_ok" onClick={this.Errortoggle}>Ok</Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={Successmodal}
          toggle={this.Successtoggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{ right: 15 }} onClick={this.Successtoggle} />



          </div>
          <div className="modal__body" style={{ paddingTop: 55, paddingBottom: 20 }}>
            <span className="lnr lnr-checkmark-circle modal__title-icon" style={{ color: 'green' }} />
            <h4>Successfully Updated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{ backgroundColor: '#24d6a3', color: '#fff' }} className="modal_ok" onClick={this.CancelSuccessToggle}>Ok</Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={Confirmmodal}
          toggle={this.Confirmtoggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{ right: 15 }} onClick={this.Confirmtoggle} />



          </div>
          <div className="modal__body" style={{ paddingTop: 55, paddingBottom: 20 }}>
            <span className="lnr lnr-checkmark-circle modal__title-icon" style={{ color: 'green' }} />
            <h4>Successfully Updated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{ backgroundColor: '#24d6a3', color: '#fff' }} className="modal_ok" onClick={this.CancelConfirmToggle}>Ok</Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={ErrorMessagemodal}
          toggle={this.ErrorMessagetoggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{ right: 15 }} onClick={this.Confirmtoggle} />



          </div>
          <div className="modal__body" style={{ paddingTop: 55, paddingBottom: 20 }}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{ color: 'red' }} />
            <h4>{this.state.errorMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button className="modal_cancel" onClick={this.CancelErrorMessageToggle}>Cancel</button>
          </ButtonToolbar>
        </Modal>


      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));
